import { FaArrowRight } from "react-icons/fa"
import Teh from '../../../assets/images/s2_teh.png'
import BoxGradient from '../../../assets/images/s2_gradient_box.png'
import Daun1 from '../../../assets/images/s2_daun_1.png'
import Daun2 from '../../../assets/images/s2_daun_2.png'

const Section2 = () => {
    return (
        <div className="w-full md:h-screen flex flex-col md:flex-row items-center justify-center pt-16 md:pt-0">
            <div className="w-full md:w-[40%] h-full flex items-center justify-start relative">
                <img src={Teh} alt="Kebun Jitu" className="max-w-[300px]  md:max-w-[350px] ml-5 md:ml-10 relative z-10" loading='lazy'/>
                <img src={Daun2} alt="Kebun Jitu" className="absolute right-8 -bottom-10 w-[250px] z-20" loading='lazy' />
                <img src={BoxGradient} alt="Kebun Jitu" className="absolute left-0 bottom-0 z-0 w-[250px]" loading='lazy' />
            </div>
            <div className="w-full md:w-[60%] space-y-3 md:pt-0 px-5 md:px-0">
                <div className="relative overflow-hidden pt-10">
                    <h1 className="text-3xl md:text-5xl font-bold text-custom-green">Welcome to</h1>
                    <h1 className="text-3xl md:text-5xl font-bold text-custom-green">Indonesia Agriculture</h1>
                    <img src={Daun1} alt="Kebun Jitu" className="absolute -right-16 md:right-0 -bottom-5
                     md:bottom-0 scale-50 md:scale-75" loading='lazy' />
                </div>
                <p className="text-justify pb-10 md:pr-10">
                Di Indonesia, jutaan petani hortikultura harus membuat keputusan penting terkait budidaya secara membabi buta karena kurangnya akses terhadap pengujian tanah, yang mengakibatkan hilangnya hasil panen hingga 30% dan pemborosan sumber daya. Layanan pengujian tanah tradisional mahal (sekitar $50-100 per tes), memakan waktu berminggu-minggu untuk memberikan hasil, dan gagal menyediakan rekomendasi yang dapat langsung diterapkan, memaksa petani mengandalkan intuisi daripada ilmu pengetahuan.

                </p>
                <button type='button' className=' text-white flex items-center justify-center gap-2 font-semibold'>
                    <span className='bg-custom-orange rounded-full px-5 py-2 capitalize'>Pelajari lebih lanjut</span>
                    <div className='rounded-full bg-custom-orange h-10 aspect-square flex items-center justify-center'>
                        <FaArrowRight />
                    </div>
                </button>
            </div>
        </div>
    )
}

export default Section2